import { getLevelApartmentCategoryCounts as n } from "../../metrics/apartment-distribution/index3.js";
function u(e, t) {
  const r = n(e, t).map((o) => ({
    ...o,
    level: t
  }));
  return { floor: t, mixes: r };
}
export {
  u as getStoryLevelApartmentCategoryCount
};
//# sourceMappingURL=index7.js.map
